import CheckIconHover from './component'

export default CheckIconHover
